export default {"src":"/_next/static/media/0x3d1556e84783672f2a3bd187a592520291442539.2e1b6b93.svg","height":129,"width":129,"blurWidth":0,"blurHeight":0};